import React from 'react';
import Footer from '../components/Footer';
import Slider from '../components/Slider'
const Lessons=()=> {
    return (
        <>
            <div className='Row'>
            <div className='Col1'></div>
            <div className='Col2'>
                <div className='empty'></div>
            <Footer />
            </div>

            </div>
    </>
    );
}

export default Lessons;